import React, { useEffect, useState } from 'react';
import { useHomedata } from '../../Admin/Homedata/HomedataProvider';
import { auth, db } from '../../Admin/Config/Config';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../Product/CartContext';
import './shimmer.css';
import { useToast } from '../../Toast.jsx/Toast';
import PriceGenerator from '../Product/PriceOperation/PriceGenerator';
import { collection, getDocs, limit, orderBy, query, where } from 'firebase/firestore';
import { useDocData } from '../../user/UserProvider';

export default function Bestratedbestprice() {
  const homeData = useHomedata();
  const navigate = useNavigate();
  const userData = useDocData();

  const handleDivClick = async (id) => {
    navigate(`/view?query=${encodeURIComponent(id)}`);
  };

  // ========================= Fetching Products ========================= //

  // const { productList, fetchProducts } = useProducts();
  const [productList, setProductList] = useState();

  const fetchProducts = async () => {
    const q = query(collection(db, "products"), where("status", "==", true),
      where("product_list_2", "==", true), orderBy("product_list_2_order", "asc"), limit(6));
    const querySnapshot = await getDocs(q);
    const products = [];
    querySnapshot.forEach((doc) => {
      products.push({ id: doc.id, ...doc.data() });
    });
    setProductList(products);
  }
  useEffect(() => {
    fetchProducts();
  }, []);

  const { addToCart } = useCart();
  const { showWarning } = useToast();

  const handleAddToCart = async (e, pro) => {
    e.stopPropagation();
    if (pro.stock < 1) {
      showWarning("Out of stock");
      return;
    }
    const quantity = getQuantity(pro.id);
    const productWithQuantity = { ...pro, cart_quantity: quantity };

    if (!auth.currentUser) {
      await addToCart("", productWithQuantity);
    } else {
      await addToCart(auth.currentUser.uid, productWithQuantity);
    }
  };



  const [quantities, setQuantities] = useState({});
  const getQuantity = (productId) => quantities[productId] || 1;

  const updateQuantity = (productId, newQuantity) => {
    console.log(newQuantity);
    if (newQuantity >= 1 && newQuantity <= 99) {
      setQuantities(prev => ({
        ...prev,
        [productId]: newQuantity
      }));
    }
  };

  const [isLoaded, setIsLoaded] = useState(false);
  const handleImageLoad = () => {
    setIsLoaded(true);
  };

  return (
    <>
      {homeData && homeData.is_row3 ? (
        <div className="p-3 sm:p-5 bg-white border border-slate-200/90 rounded-2xl shadow-sm my-6 mx-2 sm:mx-4 lg:mx-6">
          {/* Header */}
          <div className="flex justify-between items-center mb-6 px-2">
            <div className="flex items-center gap-3">
              <div className="w-1 h-8 bg-gradient-to-b from-slate-600 to-slate-800 rounded-full"></div>
              <h2 className="text-xl sm:text-2xl font-bold text-slate-800">
                {homeData && homeData.row3}
              </h2>
            </div>
            <button
              onClick={() =>
                navigate(
                  `/product-lists?no=${encodeURIComponent(
                    3
                  )}&q=${encodeURIComponent(homeData.row3)}`
                )
              }
              className="flex items-center gap-2 text-slate-600 hover:text-slate-800 font-medium transition-all duration-200 hover:gap-3 group"
            >
              <span className="text-sm sm:text-base">View All</span>
              <svg className="w-4 h-4 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>

          {/* Product Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-2 sm:gap-2.5 mt-2 sm:mt-4 px-1 sm:px-2">
            {productList &&
              productList.map((product) => {
                return (
                  <div
                    onClick={(e) => {
                      handleDivClick(product.id);
                    }}
                    key={product.id}
                    className="group relative bg-white border border-red-500 rounded-xl sm:rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:shadow-xl hover:-translate-y-1 hover:border-red-600 flex flex-col justify-between"
                  >
                    {/* Gradient overlay */}
                    <div className="absolute inset-0 bg-gradient-to-br from-slate-50/50 via-transparent to-slate-100/30 rounded-xl sm:rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"></div>

                    {/* Product Image Portion (White) */}
                    <div className="relative w-full h-24 sm:h-32 md:h-36 p-2 bg-white flex justify-center items-center overflow-hidden">
                      {!isLoaded && (
                        <div className="absolute inset-0 w-full h-full bg-gradient-to-r from-slate-200 via-slate-300 to-slate-200 animate-pulse rounded-xl"></div>
                      )}
                       {product.product_code_sku && (
                        <div className="absolute top-1.5 right-1.5 z-20 flex items-center bg-white/95 backdrop-blur-md px-1.5 py-0.5 rounded-md shadow-xs border border-slate-300/80 transition-all duration-300 group-hover:border-red-200 group-hover:bg-red-50/90">
                          <span className="text-[10px] sm:text-xs font-bold text-slate-700 font-mono leading-none group-hover:text-red-600 transition-colors duration-200">
                            {product?.product_code_sku || "N/A"}
                          </span>
                        </div>
                      )}
                      <img
                        src={product.thumb_url}
                        alt={product.product_name}
                        className={`w-full h-full object-contain transition-all duration-500 group-hover:scale-110 ${isLoaded ? "opacity-100" : "opacity-0"
                          }`}
                        onLoad={handleImageLoad}
                      />
                    </div>

                    {/* Product Info Portion (Light Beige Two-Tone) */}
                    <div className="relative z-10 p-2.5 sm:p-4 bg-[#faf6f0] border-t border-amber-100/70 flex-1 flex flex-col justify-between space-y-1.5 sm:space-y-2">
                      <div>
                        {/* Product Name */}
                        <h3 className="text-xs sm:text-sm font-semibold text-slate-700 leading-tight group-hover:text-slate-900 transition-colors duration-300 line-clamp-2 min-h-[1.8rem] sm:min-h-[2.5rem]">
                          {product.product_name.length > 45
                            ? `${product.product_name.slice(0, 45)}...`
                            : product.product_name}
                        </h3>

                        {/* Brand & Price in same row */}
                        <div className="flex items-center justify-between gap-1 mt-1 min-h-[1.5rem]">
                          {product.brand ? (
                            <div className="text-[10px] sm:text-xs font-bold uppercase tracking-wider text-red-600 bg-red-50 border border-red-100 rounded px-1.5 py-0.5 inline-block w-max truncate">
                              {product.brand}
                            </div>
                          ) : (
                            <div />
                          )}
                          <PriceGenerator product={product} userDetails={userData} priceOnly={true} />
                        </div>
                      </div>

                      {/* Quantity & Cart Section */}
                      <div>
                        {product.measure_unit && (
                          <div className="text-[10px] sm:text-xs font-semibold text-slate-600 mb-1 capitalize">
                            {product.measure_unit}
                          </div>
                        )}
                        <div className="flex items-center justify-between gap-2">
                        {/* Quantity Selector */}
                        <div className="flex items-center bg-white border border-slate-200 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200 w-full max-w-[180px]">
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              updateQuantity(product.id, getQuantity(product.id) - 1);
                            }}
                            className="flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 text-slate-500 hover:text-slate-700 hover:bg-slate-50 transition-all duration-200 rounded-l-lg group"
                            disabled={getQuantity(product.id) <= 1}
                          >
                            <svg
                              className="w-3 h-3 sm:w-4 sm:h-4 transition-transform group-active:scale-90"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M20 12H4" />
                            </svg>
                          </button>

                          <div className="flex-1 flex items-center justify-center h-8 sm:h-10 text-slate-800 font-semibold text-sm sm:text-base bg-slate-50 border-l border-r border-slate-200">
                            {getQuantity(product.id)}
                          </div>

                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              updateQuantity(product.id, getQuantity(product.id) + 1);
                            }}
                            className="flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 text-slate-500 hover:text-slate-700 hover:bg-slate-50 transition-all duration-200 rounded-r-lg group"
                            disabled={getQuantity(product.id) >= 99}
                          >
                            <svg
                              className="w-3 h-3 sm:w-4 sm:h-4 transition-transform group-active:scale-90"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                            </svg>
                          </button>
                        </div>

                        {/* Add to Cart Button */}
                        <button
                          onClick={(e) => handleAddToCart(e, product)}
                          className="relative flex items-center justify-center w-8 h-8 sm:w-9 sm:h-9 bg-gradient-to-r from-slate-700 to-slate-800 hover:from-slate-800 hover:to-slate-900 text-white rounded-xl transition-all duration-300 hover:shadow-lg hover:shadow-slate-400/30 active:scale-95 group/btn"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-4 h-4 sm:w-4 sm:h-4 transition-transform duration-300 group-hover/btn:scale-110 group-hover/btn:rotate-12"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-2.5 5M7 13l2.5 5m0 0H17M9 19.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM20 19.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
                            />
                          </svg>

                          {/* Tooltip */}
                          <div className="absolute bottom-full mb-2 left-1/2 transform -translate-x-1/2 bg-slate-800 text-white text-xs px-2 py-1 rounded whitespace-nowrap opacity-0 group-hover/btn:opacity-100 transition-opacity duration-200 pointer-events-none z-20">
                            Add to Cart
                            <div className="absolute top-full left-1/2 transform -translate-x-1/2 border-2 border-transparent border-t-slate-800"></div>
                          </div>
                        </button>
                      </div>
                    </div>

                    {/* Get Quote (if product has no price) */}
                    <PriceGenerator product={product} userDetails={userData} quoteOnly={true} />
                  </div>
                  </div>
                );
              })}
          </div>
        </div>
      ) : null}
    </>
  );
}